module.exports = __webpack_public_path__ + "static/media/screenshot-duck.80eb3582.png";